export const countThirdPartyVehiclesService =
  (fetch) =>
  async ({ filters }) => {
    try {
      const searchParams = new URLSearchParams(filters).toString();
      const response = await fetch({
        url:
          "/api/v1/inspeccion-vehiculos/contar-vehiculos-terceros?" +
          searchParams,
      });

      return response;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  };
